import axios from 'axios';
import { URL_AGREEMENT_COMMERCIAL_LIST } from './config';

export async function getCommercialList() {
    const result = await axios.get(URL_AGREEMENT_COMMERCIAL_LIST);
    return result.data.data;
};